import React, { FC } from 'react';
import { Menu, Typography, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { RemoveIcon } from '~/img';
import { Beneficiary } from '~/types';
import { useBeneficiariesDelete } from '~/hooks/beneficiaries';
import { useBeneficiaryAccountsQuery } from '~/hooks/beneficiaryAccounts';

interface Props {
  beneficiary: Beneficiary;
  [x: string]: any;
}

const DeleteAction: FC<Props> = (props) => {
  const { beneficiary, ...rest } = props;

  const { mutate } = useBeneficiariesDelete();

  const [t] = useTranslation('payouts');
  const dt = (key: string): string => t(`translation:${key}`);

  const { data } = useBeneficiaryAccountsQuery(beneficiary.id);
  const hasPendingAccounts = data?.find((account) => account.status === 'PENDING') && true;
  const hasPrimaryAccount = data?.find((account) => account.primary) && true;

  const handleDelete = () => {
    if (hasPendingAccounts) {
      Modal.warning({
        title: t('unableToDeletePendingBeneficiary'),
        icon: <ExclamationCircleOutlined />,
        okText: dt('ok'),
        okType: 'danger',
      });
    } else if (hasPrimaryAccount) {
      Modal.warning({
        title: t('unableToDeletePrimaryBeneficiary'),
        icon: <ExclamationCircleOutlined />,
        okText: dt('ok'),
        okType: 'danger',
      });
    } else {
      Modal.confirm({
        title: t('sureDelete'),
        icon: <ExclamationCircleOutlined />,
        content: t('deleteDescription'),
        okText: dt('yes'),
        okType: 'danger',
        cancelText: dt('no'),
        onOk: () => mutate(beneficiary.id),
      });
    }
  };

  return (
    <Menu.Item {...rest} key="delete" onClick={handleDelete}>
      <Typography.Text type="danger">
        <RemoveIcon />
        {dt('delete')}
      </Typography.Text>
    </Menu.Item>
  );
};

export default DeleteAction;
